import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { reduxForm, Field, change, isDirty } from 'redux-form';
import { compose } from 'redux';
import { Form } from 'react-bootstrap';
import getLanguageSelectOptions from '../../../../../shared/utils/LanguageUtils';
import BasicTextArea from '../../../../../shared/components/formComponents/groups/BasicTextArea';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import RawImageUpload from '../../../../../shared/components/formComponents/inputs/RawImageUpload';
import FormFeedback from '../../../../../shared/components/formComponents/FormFeedback';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';

class CompanyIntegrationsForm extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        submitSucceeded: PropTypes.bool,
        submitFailed: PropTypes.bool,
        onCancel: PropTypes.func,
        submitting: PropTypes.bool,
        error: PropTypes.string,
        initialValues: PropTypes.object,
        changeFormValue: PropTypes.func,
        dirty: PropTypes.bool,
        toggleShowUnsavedChangesPrompt: PropTypes.func
    };

    componentDidUpdate(prevProps) {
        if (prevProps.dirty !== this.props.dirty) {
            return this.props.toggleShowUnsavedChangesPrompt(this.props.dirty);
        }
        return null;
    }

    render() {
        const { submitting, handleSubmit, onCancel, error } = this.props;

        return (
            <Form className={'companyForm container'}>
                <Field
                    name={'lmsIntegrations.lmsNavigation.lmsLabel'}
                    label={'Navigation Label'}
                    placeholder={'Navigation Label'}
                    className={'row company-form-field'}
                    component={BasicText}
                    description={'This text will display in the hamburger navigation menu'}
                    inputClassName={'col-12 col-sm-6 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                />
                <Field
                    name={'lmsIntegrations.lmsNavigation.lmsLink'}
                    label={'Navigation Link'}
                    placeholder={'Navigation Link'}
                    className={'row company-form-field'}
                    component={BasicText}
                    description={'Enter where the navigation will link back to'}
                    inputClassName={'col-12 col-sm-6 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                />
                <Field
                    name={'lmsIntegrations.lmsCard.title'}
                    label={'LMS Card Title'}
                    className={'row company-form-field'}
                    component={BasicTextArea}
                    rows={1}
                    description={'Title displayed on the LMS card on Collection Interstitial page.'}
                    inputClassName={'col-12 col-sm-6 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                />
                <Field
                    name={'lmsIntegrations.lmsCard.link'}
                    label={'LMS Card Link'}
                    className={'row company-form-field'}
                    component={BasicTextArea}
                    rows={1}
                    description={'This is the link users will be redirected to when they click on the LMS card'}
                    inputClassName={'col-12 col-sm-6 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                />
                <Field
                    name={'lmsIntegrations.lmsCard.subtitle'}
                    label={'LMS Card Subtitle'}
                    className={'row company-form-field'}
                    component={BasicTextArea}
                    rows={1}
                    description={'Subtitle displayed on the LMS card on Collection Interstitial page.'}
                    inputClassName={'col-12 col-sm-6 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                />
                <Field
                    component={RawImageUpload}
                    name={'lmsIntegrations.lmsCard.thumbnailImageUrl'}
                    label={'LMS Card Thumbnail Image'}
                    className={'row company-form-field'}
                    description={'This is the thumbnail of the LMS card on Collection Interstitial page.'}
                    inputClassName={'col-12 col-sm-6'}
                    styleProps={{ horizontal: true }}
                    showDeleteButton={true}
                />
                <br />
                <div className={'col-12 formButtons'}>
                    <VerbButton
                        fontAwesomeIcon={'fa-save'}
                        textId={'BUTTON_SAVE'}
                        defaultMessage={'SAVE'}
                        onClick={(values) => {
                            this.setState({ formSubmitted: true });
                            handleSubmit(values);
                        }}
                        disabled={submitting}
                    />
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        fontAwesomeIcon={'fa-ban'}
                        textId={'BUTTON_CANCEL'}
                        defaultMessage={'CANCEL'}
                        onClick={onCancel}
                        disabled={submitting}
                    />
                </div>
                <FormFeedback failMsg={error} className={'col-12'} {...this.props} />
            </Form>
        );
    }
}

export const CompanyIntegrationsFormComponent = CompanyIntegrationsForm;
export const mapStateToProps = (state, ownProps) => {
    const { lmsIntegrations } = ownProps.company;

    return {
        dirty: isDirty('CompanyIntegrations'),
        initialValues: {
            lmsIntegrations
        },
        languageOptions: getLanguageSelectOptions()
    };
};

const mapDispatchToProps = (dispatch) => ({
    changeFormValue: (params) => dispatch(change('CompanyIntegrations', params.field, params.value))
});

export const CompanyIntegrationsFormValidation = {
    form: 'CompanyIntegrations',
    destroyOnUnmount: false,
    enableReinitialize: true,
    validate: ({ lmsIntegrations = {} }) => {
        const { lmsNavigation = {}, lmsCard = {} } = lmsIntegrations;
        const { lmsLabel, lmsLink } = lmsNavigation;
        const { title, link, subtitle, thumbnailImageUrl } = lmsCard;
        const errors = {
            lmsIntegrations: {
                lmsNavigation: {},
                lmsCard: {}
            }
        };

        if (lmsLink && lmsLink.length && !lmsLabel) {
            errors.lmsIntegrations.lmsNavigation.lmsLabel = (
                <span className={'form-validation-error'}>Must include a label for lms tab.</span>
            );
        }
        if (lmsLabel && lmsLabel.length && !lmsLink) {
            errors.lmsIntegrations.lmsNavigation.lmsLink = (
                <span className={'form-validation-error'}>Must include a link for lms tab.</span>
            );
        }

        const lmsCardIsCleared = Object.keys(lmsCard).every((key) => !lmsCard[key]);

        if (!isEmpty(lmsCard) && !lmsCardIsCleared && !title) {
            errors.lmsIntegrations.lmsCard.title = (
                <span className={'form-validation-error'}>Must include the title.</span>
            );
        }
        if (!isEmpty(lmsCard) && !lmsCardIsCleared && !link) {
            errors.lmsIntegrations.lmsCard.link = (
                <span className={'form-validation-error'}>Must include a link for the card.</span>
            );
        }
        if (!isEmpty(lmsCard) && !lmsCardIsCleared && !subtitle) {
            errors.lmsIntegrations.lmsCard.subtitle = (
                <span className={'form-validation-error'}>Must include the subtitle.</span>
            );
        }
        if (!isEmpty(lmsCard) && !lmsCardIsCleared && !thumbnailImageUrl) {
            errors.lmsIntegrations.lmsCard.thumbnailImageUrl = (
                <span className={'form-validation-error'}>Must include a thumbnail image.</span>
            );
        }
        return errors;
    }
};
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    reduxForm(CompanyIntegrationsFormValidation)
)(CompanyIntegrationsForm);
